// initial state
const state = {
  roomTimesFunction: 'custom/roomTimesBanqueCasino'
}

const getters = {
  roomTimesFunction () {
    return state.roomTimesFunction
  }
}

const actions = {
  roomTimesBanqueCasino ({ dispatch, commit }) {
    commit('rooms/updateRoomsTimes', {
      staticTime: true
    }, { root: true })
  },
  // eslint-disable-next-line
  sendPayment ({ }, data) {
    const payment = Object.assign(
      {}, data.payment, { kind: 'payment' })
    this._vm.$socket.send({
      cmd: 'send_message',
      room: data.uuid,
      rich_content: [payment],
      content: ''
    })
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
